<title>{{ creditCardAuthenticationPage.htmlTitle }}</title>
<app-section [sections]="creditCardAuthenticationPage.sections"></app-section>
<app-api-reference-table-section
  [tableSections]="creditCardAuthenticationPage.tableSections"
  [testingYourBuildSecureCardAuthenticationPage]="true"
  [isDefault]="false"
></app-api-reference-table-section>
